import { ComponentType, ReactNode } from 'react';
import { ReactComponent as ClockIcon } from '../../icons/assets/clock.svg';
import { CalendarIcon, LocationIcon } from '../../icons';
import { Divider, Grid, IconButton, Stack, SvgIcon, Typography } from '@mui/material';
import { BaseDialog } from '../../dialogs';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

interface ApplicationsUserDialogProps {
  statuses?: ReactNode;
  title?: string;
  text?: string;
  startDate?: string;
  startTime?: string;
  location?: string;
  createdFullDate?: string;
  popDialog?: any;
}

export const ApplicationsDialog: ComponentType<ApplicationsUserDialogProps> = ({
  statuses,
  title,
  text,
  startDate,
  startTime,
  location,
  createdFullDate,
  popDialog,
  ...props
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      <div className={classes.root}>
        {statuses && (
          <Stack direction="row" spacing={1} mb={2.5}>
            {statuses}
          </Stack>
        )}
        {title && (
          <Typography variant="h2" component="h6" mb={2}>
            {title}
          </Typography>
        )}
        {text && (
          <Typography variant="body2" component="p" mb={2}>
            {text}
          </Typography>
        )}
        {(startDate || startTime || location) && (
          <Grid container direction="column" spacing={1.5}>
            {startDate && (
              <Grid item>
                <Grid container columnSpacing={2} alignItems="center">
                  <Grid item>
                    <IconButton
                      component="div"
                      color="primary"
                      size="small"
                      className={classes.iconButton}
                    >
                      <SvgIcon component={CalendarIcon} viewBox="0 0 24 24" />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle2">{startDate}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {startTime && (
              <Grid item>
                <Grid container columnSpacing={2} alignItems="center">
                  <Grid item>
                    <IconButton
                      component="div"
                      color="primary"
                      size="small"
                      className={classes.iconButton}
                    >
                      <SvgIcon component={ClockIcon} viewBox="0 0 24 24" />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle2">{startTime}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {location && (
              <Grid item>
                <Grid container columnSpacing={2} alignItems="center">
                  <Grid item>
                    <IconButton
                      component="div"
                      color="primary"
                      size="small"
                      className={classes.iconButton}
                    >
                      <SvgIcon component={LocationIcon} viewBox="0 0 24 24" />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle2">{location}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        )}
        <Divider sx={{ mt: 3, mb: 3 }} />
        <Stack justifyContent="space-between" alignItems="center" direction="row" spacing={2}>
          <Typography variant="caption" color="grey.400">
            {createdFullDate}
          </Typography>
          <Typography variant="body3" color="secondary" className={classes.link}>
            {t('show.history.changes', 'Показать историю изменений')}
          </Typography>
        </Stack>
      </div>
    </BaseDialog>
  );
};
